import { render } from "./Formato2020.vue?vue&type=template&id=934a2ce4&scoped=true"
import script from "./Formato2020.vue?vue&type=script&lang=js"
export * from "./Formato2020.vue?vue&type=script&lang=js"

import "./Formato2020.vue?vue&type=style&index=0&id=934a2ce4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-934a2ce4"]])

export default __exports__